<template>
    <div class="invoice" id="invocie-detail">
        <SOSlotBase :bg-grey="false" :loading="isFetching">
            <template v-slot:title-bar>
                <div v-if="!fullSize">
                    <SOTitleBar :type="'back'" :page-title="page.title" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>

            <template v-slot:content v-if="!isFetching">
                <div class="p-x-20 p-t-16" style="position: relative" :class="{ preview: fullSize }">
                    <div :class="{ closeImg: !fullSize }">
                        <SOTitleBar v-if="fullSize" :type="'close'" :transparent="true" @back="closePreview" />
                        <div :id="`dokumen-preview`"></div>
                    </div>
                    <div v-if="!fullSize">
                        <div
                            v-if="isNeedConfirmed || (isExpired && dataInvoice.lunas === 0) || isCanceled"
                            class="information f-14 f-semi"
                            :class="{
                                'need-confirm': isNeedConfirmed,
                                expired: isExpired && dataInvoice.lunas === 0,
                                expired: isCanceled,
                            }"
                        >
                            <div class="d-flex-between-center">
                                <p class="m-d-0" v-if="isNeedConfirmed">
                                    <SOIconBase view-box="0 0 12 12" width="12" height="12">
                                        <template v-slot:icon>
                                            <TandaseruLingkaran1212 />
                                        </template>
                                    </SOIconBase>
                                    <span class="m-l-8">Menunggu konfirmasi pembatalan</span>
                                </p>
                                <p class="m-d-0" v-if="isExpired && dataInvoice.lunas === 0">
                                    <SOIconBase view-box="0 0 18 17" width="12" height="12">
                                        <template v-slot:icon>
                                            <WarningTriangle1817 icon-fill="#964040" />
                                        </template>
                                    </SOIconBase>
                                    <span class="m-l-8">Lewat jatuh tempo pelunasan</span>
                                </p>
                                <p class="m-d-0" v-if="isCanceled">
                                    <!-- <SOIconBase view-box="0 0 14 15" width="12" height="12">
                                        <template v-slot:icon>
                                            <AlertInfo1415 />
                                        </template>
                                    </SOIconBase> -->
                                    <span class="m-l-8">Invoice dibatalkan</span>
                                </p>
                                <p class="m-d-0 f-c-blue" v-if="isNeedConfirmed || isCanceled" @click="goDetailInfo">
                                    <span class="">Detail</span>
                                </p>
                            </div>
                        </div>
                        <div class="inv-id m-d-16 f-reg-black f-16">
                            <p class="m-d-0 f-12 f-reg-grey d-flex-between-center" style="justify-content: unset">
                                <SOIconBase view-box="0 0 16 16" width="12" height="12">
                                    <template v-slot:icon>
                                        <OutletOut1616 icon-fill="#000000" />
                                    </template>
                                </SOIconBase>
                                <span class="m-l-4">{{ dataInvoice.namaOutlet }}</span>
                            </p>
                            <p class="m-d-4 f-semi">{{ dataInvoice.idmasalTransaksi }}</p>
                            <p class="m-d-0 f-13">
                                <span class="f-c-midgrey">Dibuat oleh </span>
                                <span v-if="isOwner(dataInvoice.idkaryawan, dataInvoice.namaKaryawan)"> Owner </span>
                                <span v-else>{{ dataInvoice.namaKaryawan }}</span>
                            </p>
                        </div>
                        <div class="separator"></div>
                        <div class="inv-to m-t-16 m-d-16 f-reg-black f-16">
                            <div class="m-d-8 d-flex-between-center">
                                <label class="m-d-0 f-c-midgrey">Nama Penerima</label>
                                <label class="m-d-0">{{ dataInvoice.penerima }}</label>
                            </div>
                            <div class="m-d-12 d-flex-between-center">
                                <label class="m-d-0 f-c-midgrey">No Whats App</label>
                                <label class="m-d-0">{{ dataInvoice.penerimaWa }}</label>
                            </div>
                            <div class="separator-line" style="margin: 0px"></div>
                            <div class="m-d-8 m-t-12 d-flex-between-center">
                                <label class="m-d-0 f-c-midgrey">Transaksi</label>
                                <label class="m-d-0">
                                    {{ $moment(dataInvoice.periodeAwal).format("Do MMM YYYY") }} s.d
                                    {{ $moment(dataInvoice.periodeAkhir).format("Do MMM YYYY") }}
                                </label>
                            </div>
                            <div class="m-d-8 d-flex-between-center">
                                <label class="m-d-0 f-c-midgrey">Waktu dibuat</label>
                                <label class="m-d-0">{{ dayFormated(dataInvoice.createdAt, $moment) }}</label>
                            </div>
                            <div class="m-d-8 d-flex-between-center">
                                <label class="m-d-0 f-c-midgrey">Jatuh tempo</label>
                                <label class="m-d-0 f-c-red">{{ dayFormated(dataInvoice.jatuhTempo, $moment) }}</label>
                            </div>
                        </div>
                        <div class="separator"></div>
                        <div class="m-t-16 inv-consument m-d-16">
                            <SODetailExpand id="data-consument" :full-height="fullHeight">
                                <template v-slot:header-content>
                                    <p class="m-d-0 f-16 f-reg-black d-flex">
                                        <SOIconBase view-box="0 0 24 25" width="20" height="21">
                                            <template v-slot:icon>
                                                <User2425 icon-fill="#000000" />
                                            </template>
                                        </SOIconBase>
                                        <span class="m-l-8 f-bold">{{ konsumenTotal }} Konsumen</span>
                                    </p>
                                </template>
                                <template v-slot:content>
                                    <div class="list-consument f-reg-grey f-14">
                                        <div class="d-grid-12 header-list f-bold">
                                            <p class="grid-cspan-6 m-d-0">Nama</p>
                                            <p class="grid-cspan-6 m-d-0">Nomor telp</p>
                                        </div>
                                        <div class="body-list">
                                            <CardConsument :data-list="konsumenList" :load-data="loadDataKonsumen" />
                                        </div>
                                    </div>
                                </template>
                            </SODetailExpand>
                        </div>
                        <div class="separator"></div>
                        <div class="m-t-16 m-d-20">
                            <div class="center status-inv">
                                <p class="m-d-0 f-14 f-semi">
                                    <span class="m-r-8">Status</span>
                                    <label class="belum-bayar" v-if="dataInvoice.lunas === 0">Blm Bayar</label>
                                    <label class="lunas" v-else>Lunas</label>
                                </p>
                            </div>
                        </div>
                        <div class="inv-tagihan" v-if="showCard">
                            <div class="d-flex-between-center m-d-16">
                                <div>
                                    <p class="m-d-0 f-16 f-reg-black d-flex">
                                        <SOIconBase view-box="0 0 24 25" width="20" height="21">
                                            <template v-slot:icon>
                                                <PaySlip2425 icon-fill="#000000" />
                                            </template>
                                        </SOIconBase>
                                        <span class="m-l-8 f-16 f-c-black f-bold">1 Tagihan</span>
                                    </p>
                                </div>
                                <div class="d-flex f-c-blue" @click="goDetailTagihan">
                                    <span class="m-r-8">Detail</span>
                                    <div style="transform: rotate(-90deg)">
                                        <SOIconBase view-box="0 0 16 17" width="16" height="17">
                                            <template v-slot:icon>
                                                <ArrowDown1617 icon-fill="#206CFF" />
                                            </template>
                                        </SOIconBase>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="tagihan d-flex-between-center m-d-12"
                                v-for="(tagihan, idx) in getTagihans"
                                :key="`tagihan${idx}`"
                            >
                                <p class="m-d-0 f-14 f-reg-black">
                                    <span v-if="$moment(tagihan.key).isValid()">Transaksi </span>
                                    <span>{{ dayFormated(tagihan.key, $moment, true) }}</span>
                                    <br />
                                    <span class="f-c-midgrey f-12">{{ tagihan.countTransaksi }} transaksi</span>
                                </p>
                                <p class="m-d-0 f-reg-black f-14">{{ tagihan.tagihan | decimal }}</p>
                            </div>
                            <div class="separator-line-dot m-d-16" style=""></div>
                            <div class="d-flex-between-center m-d-16">
                                <p class="m-d-0">Total Invoice</p>
                                <p class="m-d-0">Rp {{ getTotalTagihan | decimal }}</p>
                            </div>
                            <div class="separator-line" style="margin: 0px 0px; border-width: 3px"></div>
                            <div class="d-flex-between-center m-t-16" v-if="dataInvoice.lunas === 0">
                                <p class="m-d-0 f-c-red">Belum Dibayar</p>
                            </div>
                            <div class="m-t-16" v-else>
                                <p class="f-c-black f-bold f-16">Pembayaran</p>
                                <div class="d-flex-between-center m-d-16">
                                    <p class="m-d-0 f-reg-black f-14">
                                        <span>{{ getMetodeBayar(dataInvoice.idjenisbayar) }}</span>
                                        <br />
                                        <span class="f-c-midgrey f-12">
                                            {{ dayFormated(dataInvoice.tanggalBayar, $moment) }} oleh
                                            {{
                                                isOwner(dataInvoice.idkaryawan, dataInvoice.namaKaryawan)
                                                    ? "Owner"
                                                    : dataInvoice.namaKaryawan
                                            }}
                                        </span>
                                    </p>
                                    <p class="m-d-0">{{ getTotalTagihan | decimal }}</p>
                                </div>
                                <div class="separator-line-dot m-d-16" style=""></div>
                                <div class="d-flex-between-center">
                                    <p class="m-d-0">Terbayar</p>
                                    <p class="m-d-0">Rp {{ dataInvoice.sisaBayar | decimal }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="pengaturan-lain m-t-20">
                            <p class="m-d-16 f-16 f-bold f-c-black">Data & Pengaturan Lain</p>
                            <div class="pengaturan f-13 f-reg-black m-d-12">
                                <label class="m-d-4 f-14 f-reg-grey">Pengaturan</label>
                                <div class="item-pengaturan">
                                    <div
                                        class="d-flex-between-center p-x-16 p-y-8"
                                        style="border-bottom: 1px solid #ededed"
                                    >
                                        <p class="m-d-0 f-reg-grey">Logo outlet</p>
                                        <p class="m-d-0">
                                            <span v-if="dataInvoice.showLogoOutlet === 0">Tidak Tampil</span>
                                            <span v-else>Tampil</span>
                                        </p>
                                    </div>
                                    <div
                                        class="d-flex-between-center p-x-16 p-y-8"
                                        style="border-bottom: 1px solid #ededed"
                                    >
                                        <p class="m-d-0 f-reg-grey">Dokumentasi transaksi</p>
                                        <span v-if="dataInvoice.showDocumentation === 0">Tidak Tampil</span>
                                        <span v-else>Tampil</span>
                                    </div>
                                    <div
                                        class="d-flex-between-center p-x-16 p-y-8"
                                        style="border-bottom: 1px solid #ededed"
                                    >
                                        <p class="m-d-0 f-reg-grey">Pengelompokan data</p>
                                        <p class="m-d-0">{{ getJenisPengelompokan(dataInvoice.tipeKelompok) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="pengaturan f-13 f-reg-black m-d-12">
                                <label class="m-d-4 f-14 f-reg-grey">Pengingat Pelunasan</label>
                                <div class="item-pengingat">
                                    <div
                                        class="d-flex-between-center p-x-16 p-y-8"
                                        style="border-bottom: 1px solid #ededed"
                                    >
                                        <p class="m-d-0 f-reg-grey">Hari Jatuh Tempo</p>
                                        <p class="m-d-0">
                                            Dikirim pukul {{ timeFormated(dataInvoice.jatuhTempo, $moment) }}
                                        </p>
                                    </div>
                                    <div
                                        class="d-flex-between-center p-x-16 p-y-8"
                                        style="border-bottom: 1px solid #ededed"
                                        v-for="(reminder, key) in dataInvoice.jsonReminder.split(',')"
                                        :key="`reminder-${key}`"
                                    >
                                        <p class="m-d-0 f-reg-grey">{{ reminder }} hari sebelum jatuh tempo</p>
                                        <p class="m-d-0">
                                            Dikirim pukul {{ timeFormated(dataInvoice.jatuhTempo, $moment) }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="pengaturan f-14 f-reg-black m-d-12">
                                <label class="m-d-4 f-reg-grey">Dokumentasi</label>
                                <div class="item-dokumentasi">
                                    <div
                                        class="img-container"
                                        v-for="(img, idx) in getDokumentasi"
                                        :key="`${idx}-dokumen`"
                                    >
                                        <img
                                            :id="`${idx}-dokumen`"
                                            :src="`${imageStore}${img.path}${img.name}`"
                                            @click="setFullSize(idx)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="pengaturan f-14 f-reg-black m-d-12">
                                <label class="m-d-4 f-reg-grey">Keterangan</label>
                                <div class="item-keterangan">
                                    <span>{{ dataInvoice.keterangan }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="action-btn">
                            <div v-if="dataInvoice.lunas === 0 && !isNeedConfirmed && !isCanceled">
                                <SOButton
                                    :primary="true"
                                    :full="true"
                                    :text="'Lunasi Invoice'"
                                    :disable="isFetching"
                                    :loading="isFetching"
                                    :id="`lunasi-inv`"
                                    @action="onLunasi"
                                />
                            </div>
                            <div class="d-grid-12 align-items-center" v-if="isNeedConfirmed">
                                <div class="grid-cspan-6" style="padding-right: 8px">
                                    <SOButton
                                        :outline="true"
                                        :full="true"
                                        :text="'Tolak'"
                                        :id="`btn_tolak_inv`"
                                        @action="goTolak"
                                    />
                                </div>
                                <div class="grid-cspan-6 p-l-8">
                                    <SOButton
                                        :primary="true"
                                        :full="true"
                                        :text="'Setujui'"
                                        :id="`btn_terima_inv`"
                                        @action="goTerima"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SODetailExpand from "@/so-components/global/ui/SODetailExpand";
import SOButton from "@/so-components/global/ui/SOButton";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import OutletOut1616 from "@/so-components/global/icons/iconPacks/OutletOut1616.vue";
import User2425 from "@/so-components/global/icons/iconPacks/User2425.vue";
import PaySlip2425 from "@/so-components/global/icons/iconPacks/PaySlip2425.vue";
import ArrowDown1617 from "@/so-components/global/icons/iconPacks/ArrowDown1617.vue";
import TandaseruLingkaran1212 from "@/so-components/global/icons/iconPacks/TandaseruLingkaran1212.vue";
import WarningTriangle1817 from "@/so-components/global/icons/iconPacks/WarningTriangle1817.vue";
import AlertInfo1415 from "@/so-components/global/icons/iconPacks/AlertInfo1415.vue";

import CardConsument from "../components/CardConsument.vue";
import metodeBayar from "../static/metodeBayar";

export default {
    name: "InvoiceDetail",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SODetailExpand,
        SOIconBase,
        SOButton,
        OutletOut1616,
        User2425,
        PaySlip2425,
        ArrowDown1617,
        TandaseruLingkaran1212,
        WarningTriangle1817,
        AlertInfo1415,
        CardConsument,
    },
    data() {
        return {
            page: {
                title: "Detail Invoice",
                loading: false,
            },
            fullSize: false,
            isNotification: false
        };
    },
    mounted() {
        this.isNotification = this.$route.query.is_notification == "1"
        this.init();
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === "invoice.detail.tolak_permintaan" || from.name === "invoice.detail.terima_permintaan") {
                vm.scrollToBottom();
            }
        });
    },
    watch: {
        response: function (nRes, oRes) {
            if (nRes !== oRes) {
                if (nRes.success) {
                    if (nRes.success === false) {
                        this.$toast.error(nRes.err);
                    }

                    this.setLoading(false);
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            konsumenList: "konsumenList",
            konsumenTotal: "konsumenTotal",
            imageStore: "imageStore",
            dayFormated: "dayFormated",
            timeFormated: "timeFormated",
            response: "response",
            invoiceData: "invoiceData",
            isOwner: "isOwner",
        }),
        showCard() {
            if (this.dataInvoice.lunas === 0) {
                return true
            }
            else {
                return this.dataInvoice.idjenisbayar > 0
            }
        },
        invoiceId() {
            return this.$route.params.invoiceId;
        },
        dataInvoice() {
            return this.invoiceData.dataInvoice;
        },
        getTagihans() {
            return this.invoiceData.transaksi;
        },
        getTotalTagihan() {
            return parseFloat(this.invoiceData.total);
        },
        getJenisPengelompokan() {
            return (typePengelompokan) => {
                switch (typePengelompokan) {
                    case 1:
                        return "Tanggal Transaksi";
                    case 2:
                        return "Status Transaksi";
                    case 3:
                        return "Konsumen";
                    default:
                        return "";
                }
            };
        },
        isFetching() {
            return this.page.loading;
        },
        isNeedConfirmed() {
            return this.invoiceData.dataInvoice.statusPembatalan === 1;
        },
        isExpired() {
            return this.invoiceData.dataInvoice.statusPembatalan === 3;
        },
        isCanceled() {
            return this.invoiceData.dataInvoice.statusPembatalan === 2;
        },
        getDokumentasi() {
            let docs = [];
            this.invoiceData.transaksiFoto.forEach((foto) => {
                docs.push({
                    name: foto.cloudName,
                    path: `${foto.cloudBucket}/`,
                });
            });
            return docs;
        },
        statusInvoice() {
            return () => {};
        },
        fullHeight() {
            let lengthItem = this.konsumenTotal > 8 ? 8 : parseInt(this.konsumenTotal);
            return 42 * (lengthItem + 1);
        },
        getMetodeBayar() {
            return (idjenisbayar) => {
                let metode = metodeBayar.find((m) => m.value == idjenisbayar);
                console.log(metodeBayar, idjenisbayar);
                return metode.title ? metode.title : "";
            };
        },
    },
    methods: {
        ...mapActions({
            getDetailInvoice: `${moduleName}/getDetailInvoice`,
            getListKonsumen: `${moduleName}/getListKonsumen`,
            resetList: `${moduleName}/resetList`,
            resetPage: `${moduleName}/resetPage`,
        }),
        back() {
            this.$router.push({ name: "invoice.list" });
        },
        async init() {
            await this.setLoading(true);
            await this.getDetailInvoice({ invoiceId: this.invoiceId });
            await this.resetKonsument();
            await this.loadDataKonsumen();
        },
        scrollToBottom() {
            window.scrollTo(0, document.body.scrollHeight);
        },
        resetKonsument() {
            this.resetPage({ target: "konsumen" });
            this.resetList({ target: "konsumen" });
        },
        loadDataKonsumen() {
            this.getListKonsumen({ invoiceId: this.invoiceId });
        },
        onLunasi() {
            this.$router.push({ name: "invoice.detail.pembayaran" });
        },
        goTolak() {
            this.$router.push({ name: "invoice.detail.tolak_permintaan", params: {isNotification: this.isNotification} });
        },
        goTerima() {
            this.$router.push({
                name: "invoice.detail.terima_permintaan",
                query: {
                    idKaryawan: this.dataInvoice.idkaryawan,
                    isLunas: this.dataInvoice.lunas === 1,
                    nominal: this.dataInvoice.terbayar,
                },
                params: {isNotification: this.isNotification}
            });
        },
        goDetailInfo() {
            this.$router.push({ name: "invoice.detail.detail_info", query: { data: this.dataInvoice } });
        },
        goDetailTagihan() {
            this.$router.push({ name: "invoice.detail.detail_tagihan" });
        },
        setFullSize(idx) {
            this.fullSize = true;

            let { getDokumentasi, imageStore } = this;
            let el = document.getElementById(`dokumen-preview`);

            if (el.childNodes[0]) {
                el.removeChild(el.childNodes[0]);
            }

            setTimeout(() => {
                let img = new Image();
                img.src = `${imageStore}${getDokumentasi[idx].path}${getDokumentasi[idx].name}`;
                img.width = el.offsetWidth;
                img.onload = function () {
                    el.appendChild(img);
                };

                window.scrollTo(0, 0);
            }, 100);
        },
        closePreview() {
            this.fullSize = false;
        },
        setLoading(val) {
            this.page.loading = val;
        },
    },
};
</script>
<style scoped src="../static/style.css"></style>
<style scoped>
.action-btn {
    position: fixed;
    bottom: 65px;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    z-index: 200;
    background-color: white;
}
</style>
